<template>
  <div>
    <div>
      <el-button size="mini" icon="el-icon-plus" @click="editPro(null)">添加项目</el-button>
      <div style="color: red;">点击项目名称进行修改</div>
    </div>
    <div v-for="type in projects" style="margin-bottom: 10px;">
      <span style="font-size: 18px;font-weight: 600;">{{ type.ProjectTypeName }}</span>

      <div style="margin-top: 5px;">
        <el-tag @click="editPro(item)" size="small" closable @close="handleDel(item)" 
        style="margin: 5px 5px;cursor: pointer;"
          v-for="item in type.CommonProjects">
          <!-- <i style="font-size: 14px;" v-if="item.AthleteNumberType == 0" class="el-icon-user"></i>
          <i style="font-size: 16px;" v-if="item.AthleteNumberType == 1" class="el-icon-tuandui"></i> -->
          {{ item.ProjectName }}</el-tag>
      </div>
    </div>

    <el-dialog title="编辑" :visible.sync="dialogVisible" width="600px">
      <el-form :model="editForm" ref="editForm" :rules="editFormRules" style="width: 80%;margin: 0 auto;"
        label-width="120px">
        <el-form-item label="项目名称" prop="ProjectName">
          <el-input v-model="editForm.ProjectName" size="small" style="width: 300px;"></el-input>
        </el-form-item>
        <el-form-item label="项目类型" prop="ProjectTypeId">
          <el-select size="small" v-model="editForm.ProjectTypeId" style="width: 300px;">

            <el-option v-for="t in types" :value="t.ProjectTypeId" :label="t.ProjectTypeName" />
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="运动员类型" prop="AthleteNumberType">
          <el-radio v-model="editForm.AthleteNumberType" :label="0">
            <i style="font-size: 14px;" class="el-icon-user"></i>
            个人</el-radio>
          <el-radio v-model="editForm.AthleteNumberType" :label="1">
            <i style="font-size: 16px;" class="el-icon-tuandui"></i>
            团队</el-radio>
        </el-form-item> -->
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" type="primary" @click="submitEditPro">提 交</el-button>
        <el-button type="info" size="small" @click="dialogVisible = false">取 消</el-button>

      </span>
    </el-dialog>

  </div>
</template>

<script>
import SystemService from "@/request-server/request-services/system-services.js";
import MatchService from "@/request-server/request-services/match-services.js";
import utilsCommon from '../../../utils/utils-common';
export default {
  data() {
    return {
      types: [],
      projects: [],
      editForm: {
        ProjectId: '',
        ProjectName: '',
        ProjectTypeId: '',
        AthleteNumberType:0,
      },
      editFormRules:{
        ProjectName:[  { required: true, message: '请填写项目名称', trigger: 'blur' }],
        ProjectTypeId:[  { required: true, message: '请选择项目类型', trigger: 'blur' }],
        // AthleteNumberType: [{ required: true, message: '请选择运动员类型', trigger: 'blur' }],
      },
      dialogVisible: false,
    };
  },
  created() {
    this.initProData();
    this.initTypeData();
  },
  methods: {
    initProData() {
      SystemService.getCommonMatchProjects().then(res => {
        if (res.code == 0) this.projects = res.data
      })
    },
    initTypeData() {
      MatchService.selectProjectTypeList().then(res => {
        if (res.code == 0) this.types = res.data;
      })
    },
    editPro(pro) {
      if (pro) {
        this.editForm = utilsCommon.copyObj(pro);
      } else {
        this.editForm = {
          ProjectId: '',
          ProjectName: '',
          ProjectTypeId: '',
          AthleteNumberType:0,
        }
      }
      this.dialogVisible = true;
    },
    submitEditPro(){
      this.$refs['editForm'].validate((valid) => {
        if (valid) {
          SystemService.editCommonMatchProjects([this.editForm]).then(res => {
            if (res.code == 0) {
              this.$message.success(res.data);
              this.initProData();
              this.dialogVisible = false;
            }
          })
        }
      });
    },
    handleDel(pro) {
      this.$confirm(
        "是否确认要删除该项目？",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(() => {
          SystemService.delCommonMatchProject({ proId: pro.ProjectId }).then((res) => {
            if (res.code == 0) {
              this.$message.success(res.data);
              this.initProData();
            }
          });
        })
        .catch(() => { });
    }
  },
};
</script>

<style lang="scss" scoped>
:deep(.el-radio input[aria-hidden="true"]) {
  display: none !important;
}

:deep(.el-radio:focus:not(.is-focus):not(:active):not(.is-disabled) .el-radio__inner) {
  box-shadow: none !important;
}
</style>
